import React, { useEffect, useState } from "react";
import ManageProjects from "./ManageProjects";
import Profile from "./Profile";
import SettingHeader from "./SettingHeader";
import ShareComponent from "./share-component/ShareComponent";
import SummaryPrompt from "./SummaryPrompts";
import Personas from "./Personas";
import { RoleRightsForModule, debounce } from "../../utils/utils";
import Button from "../form-components/Button";
import ChatSetting from "./ChatSettings";
import Tones from "./Tones";
import trashImg from "../../assets/images/trash.svg";

const DeleteButton = ({ label, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="btn d-flex dlet-btn tooltip-button"
    >
      <img
        src={trashImg}
        alt=""
      />
      <div className="tooltip-div">{label}</div>
    </button>
  )
}

const RightComponent = ({ searchValue, onSearch, addBtnText, addBtnClick }) => {
  const debounceSearch = debounce((e, setFn) => {
    setFn(e.target.value);
  }, 600);

  return (
    <div className="col-12 col-md-7 col-lg-8 col-xl-6 mt-3 mt-md-0 text-start text-md-end">
      <div className="user-right-filter-grup justify-content-md-end">
      <div className="intro-searchbar">
        <button type="submit" className="filter-search-btn"></button>
        <input
          type="text"
          className="form-control"
          placeholder="Search"
          defaultValue={searchValue}
          onChange={e => { e.persist(); debounceSearch(e, onSearch); }}
          autoFocus={Boolean(searchValue)}
        />
      </div>
      <Button
        type="button"
        className="btn btn-primary-md"
        onClick={addBtnClick}
      >
        {addBtnText}
      </Button>
      </div>
    </div>
  );
}

const RightSideComponent = ({ subCategories }) => {
  const [currentModal, setCurrentModal] = useState("");
  const [searchSummaryPrompt, setSearchSummaryPrompt] = useState("");
  const [searchPersona, setSearchPersona] = useState("");
  const [searchTones, setSearchTones] = useState("");
  const [showPersonaBulkDeleteBtn, setShowPersonaBulkDeleteBtn] = useState(false);
  const [showToneBulkDeleteBtn, setShowToneBulkDeleteBtn] = useState(false);
  const [showSummaryPromptBulkDeleteBtn, setShowSummaryPromptBulkDeleteBtn] = useState(false);

  const toggleFunction = () => {
    setCurrentModal("");
  };

  const manageProjectsRightComponent = () => {
    return (
      <>
        {RoleRightsForModule("Add", "Manage Projects") && (
          <div className="col-12 col-md-7 col-lg-8 col-xl-6 mt-3 mt-md-0 text-start text-md-end">
            <Button
              type="button"
              className="btn btn-primary-md"
              onClick={() => setCurrentModal("addProjectModal")}
            >
              + Add Project
            </Button>
          </div>
        )}
      </>
    );
  };

  const summaryPromptRightComponent = () => {
    return (
      <RightComponent
        searchValue={searchSummaryPrompt}
        onSearch={setSearchSummaryPrompt}
        addBtnText="+ Add Summary Prompt"
        addBtnClick={() => setCurrentModal("addSummaryPrompt")}
      />
    )
  }

  const summaryPromptLeftComponent = () => {
    return (
      <>
      {showSummaryPromptBulkDeleteBtn
        ? <DeleteButton
            label="Delete Summary Prompts"
            onClick={() => setCurrentModal("bulkDeleteSummaryPrompts")}
          />
          : null
        }
      </>
    )
  }

  const personaRightComponent = () => {
    return (
      <RightComponent
        searchValue={searchPersona}
        onSearch={setSearchPersona}
        addBtnText="+ Add Persona"
        addBtnClick={() => setCurrentModal("addPersona")}
      />
    )
  };

  const personaLeftComponent = () => {
    return (
      <>
      {showPersonaBulkDeleteBtn
        ? <DeleteButton
            label="Delete Personas"
            onClick={() => setCurrentModal("bulkDeletePersonas")}
          />
          : null
        }
      </>
    )
  }

  const tonesRightComponent = () => {
    return (
      <RightComponent
        searchValue={searchTones}
        onSearch={setSearchTones}
        addBtnText="+ Add Tones"
        addBtnClick={() => setCurrentModal("addTone")}
      />
    )
  };

  const toneLeftComponent = () => {
    return (
      <>
      {showToneBulkDeleteBtn
        ? <DeleteButton
            label="Delete Tones"
            onClick={() => setCurrentModal("bulkDeleteTones")}
          />
          : null
        }
      </>
    )
  }

  return (
    <div>
      {subCategories === "profile" && (
        <>
          <SettingHeader title="Manage Profile" />
          <Profile
            currentModal={currentModal}
            setCurrentModal={setCurrentModal}
            toggleFunction={toggleFunction}
          />
        </>
      )}
      {subCategories === "manageProjects" && (
        <>
          <SettingHeader
            title="Manage Projects"
            RightComponent={manageProjectsRightComponent}
          />
          <ManageProjects
            currentModal={currentModal}
            setCurrentModal={setCurrentModal}
            toggleFunction={toggleFunction}
          />
        </>
      )}
      {subCategories === "share" && (
        <>
          <ShareComponent subCategories={subCategories} />
        </>
      )}
      {subCategories === "summaryPrompts" && (
        <>
          <SettingHeader
            title="Summary Prompts"
            LeftComponent={summaryPromptLeftComponent}
            RightComponent={summaryPromptRightComponent}
          />
          <SummaryPrompt
            currentModal={currentModal}
            setCurrentModal={setCurrentModal}
            toggleFunction={toggleFunction}
            searchText={searchSummaryPrompt}
            setShowSummaryPromptBulkDeleteBtn={setShowSummaryPromptBulkDeleteBtn}
          />
        </>
      )}
      {subCategories === "personas" && (
        <>
          <SettingHeader
            title="Personas"
            LeftComponent={personaLeftComponent}
            RightComponent={personaRightComponent}
          />
          <Personas
            currentModal={currentModal}
            setCurrentModal={setCurrentModal}
            toggleFunction={toggleFunction}
            setShowPersonaBulkDeleteBtn={setShowPersonaBulkDeleteBtn}
            searchText={searchPersona}
          />
        </>
      )}
      {subCategories === "chatSettings" && (
        <>
          <SettingHeader title="Chat Settings" />
          <ChatSetting />
        </>
      )}
      {subCategories === "tones" && (
        <>
          <SettingHeader
            title="Tones"
            LeftComponent={toneLeftComponent}
            RightComponent={tonesRightComponent}
          />
          <Tones
            currentModal={currentModal}
            setCurrentModal={setCurrentModal}
            toggleFunction={toggleFunction}
            setShowToneBulkDeleteBtn={setShowToneBulkDeleteBtn}
            searchText={searchTones}
          />
        </>
      )}
    </div>
  );
};

export default RightSideComponent;
